import { State } from '../../types';

export const newMexico: State = {
  name: 'New Mexico',
  abbreviation: 'NM',
  terms: [
    {
      word: 'Abiquiú',
      phonetic: 'AB-ick-you',
      // audioUrl: '/audio/abiquiu.mp3',
      description: 'A small town known for its rich history and as the home of artist Georgia O\'Keeffe. Often mispronounced due to its unique spelling.'
    },
    {
      word: 'Agave',
      phonetic: 'uh-GAH-vee',
      description: 'A common desert plant name in the Southwest. Often mispronounced as "uh-GAH-vay."'
    },
    {
      word: 'Arroyo Seco',
      phonetic: 'Ahr-oi-ya say-ko',
      // audioUrl: '/audio/arroyo_seco.mp3',
      description: 'A village in Taos County, with a name meaning "dry stream" in Spanish.'
    },
    {
      word: 'Caballo',
      phonetic: 'Ka-vah-yoh',
      // audioUrl: '/audio/caballo.mp3',
      description: 'A town named after the Spanish word for "horse," often mispronounced by non-Spanish speakers.'
    },
    {
      word: 'Creosote',
      phonetic: 'KREE-uh-soht',
      description: 'The creosote bush, common in Southwestern deserts. Often mispronounced as "KREE-oh-soht."'
    },
    {
      word: 'Chimayó',
      phonetic: 'Chee-my-oh',
      // audioUrl: '/audio/chimayo.mp3',
      description: 'A community famous for its sanctuary and weaving traditions, with a name that can be challenging for visitors.'
    },
    {
      word: 'Jemez',
      phonetic: 'Hay-mess',
      // audioUrl: '/audio/jemez.mp3',
      description: 'Refers to the Jemez Mountains and Pueblo, with a pronunciation that differs from its spelling.'
    },
    {
      word: 'Lamy',
      phonetic: 'Lay-mee',
      // audioUrl: '/audio/lamy.mp3',
      description: 'A small town south of Santa Fe, often mispronounced due to its simple spelling.'
    },
    {
      word: 'Madrid',
      phonetic: 'MAD-rid',
      audioUrl: '/audio/madrid-nm.mp3',
      description: 'Historic mining town'
    },
    {
      word: 'Mogollon',
      phonetic: 'Moh-goy-own',
      // audioUrl: '/audio/mogollon.mp3',
      description: 'A ghost town in Catron County, with a name derived from Spanish that is often mispronounced.'
    },
    {
      word: 'Pojoaque',
      phonetic: 'Poh-wah-kay',
      // audioUrl: '/audio/pojoaque.mp3',
      description: 'A pueblo and census-designated place, with a Tewa name meaning "water drinking place."'
    },
    {
      word: 'Taos',
      phonetic: 'Towce (like house with a T)' ,
      // audioUrl: '/audio/tesuque.mp3',
      description: 'A town in northern New Mexico’s high desert, bounded by the Sangre de Cristo Mountains'
    },
    {
      word: 'Tesuque',
      phonetic: 'Teh-sue-keh',
      // audioUrl: '/audio/tesuque.mp3',
      description: 'A census-designated place and pueblo, with a Tewa name meaning "narrow place of cottonwood trees."'
    },
    {
      word: 'Tucumcari',
      phonetic: 'Too-come-care-ee',
      // audioUrl: '/audio/tucumcari.mp3',
      description: 'A city on historic Route 66, with a name that poses pronunciation challenges for many.'
    }
  ]
};
